import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';
import routeSummaryActions from 'react/api/actions/routeSummary';
import { getResourceTo, toastNotification } from 'react/utils/utils';

function* assignDriver(action) {
  const { drivers } = action.payload;
  const stopCandidate = yield select((state) =>
    state?.routeSummary.get('stopCandidate')
  );
  if (!stopCandidate || !drivers.length) {
    return;
  }
  const { route } = stopCandidate.attributes;
  const payload = drivers.map((driver) => ({
    driver: { id: driver.id },
    route: { id: route.id }
  }));
  const result = yield call(
    defaultFetch,
    encodeURI('/RouteDriver/batch'),
    payload,
    'POST'
  );
  const { error } = result;
  if (!error) {
    yield put(
      routeSummaryActions.actionCreators.assignDriverModal.closeModal()
    );
    const arriveStopPopup = new window.Greenmile.Stop.Arrive();
    arriveStopPopup.setStop(stopCandidate);
    arriveStopPopup.setRouteId(route.id);
    arriveStopPopup.show();
    return;
  }
  yield call(toastNotification.addToast, {
    id: 'multi-search-on-map-alert',
    type: 'error',
    variant: 'secondary',
    data: {
      title: getResourceTo('alertgenericmodal.header.title.default'),
      description: window.Monet.Form.Messages.getErrorMessageToBeDisplayed(
        error.errorMessages
      )
    }
  });
}

function* watchRouteSummaryAssignDriver() {
  yield takeLatest(
    routeSummaryActions.actions.dispatchAssignDriver,
    assignDriver
  );
}

function* routeSummarySaga() {
  yield all([watchRouteSummaryAssignDriver()]);
}

export default routeSummarySaga;
